import React from 'react'
import { css, StyleSheet } from 'aphrodite'

const COMPANY = 'iAgro'
const SUPPORT_EMAIL = 'support@iagro.uz'

// Google Play "Data deletion" va Apple talabiga mos ommaviy sahifa:
// akkaunt va maʼlumotlarni qanday oʼchirish mumkinligini tushuntiradi.
export default function DeleteAccount() {
    return (
        <div className={css(styles.page)}>
            <div className={css(styles.container)}>
                <h1 className={css(styles.title)}>Akkauntni oʼchirish</h1>
                <p className={css(styles.updated)}>{COMPANY} ilovasi</p>

                <Section title="Ilova ichidan oʼchirish (tavsiya etiladi)">
                    <p className={css(styles.p)}>
                        Hisobingizni istalgan vaqtda ilovaning oʼzidan oʼchirishingiz mumkin:
                    </p>
                    <ol className={css(styles.list)}>
                        <li>{COMPANY} ilovasiga kiring;</li>
                        <li><b>Sozlamalar</b> boʼlimini oching;</li>
                        <li><b>Akkauntni oʼchirish</b> tugmasini bosing;</li>
                        <li>Tasdiqlang — hisobingiz va unga bogʼliq barcha maʼlumotlar darhol oʼchiriladi.</li>
                    </ol>
                </Section>

                <Section title="Soʼrov orqali oʼchirish">
                    <p className={css(styles.p)}>
                        Ilovaga kira olmasangiz, hisobingiz bilan bogʼliq elektron pochtadan
                        {' '}<a className={css(styles.link)} href={`mailto:${SUPPORT_EMAIL}?subject=Akkauntni o'chirish`}>{SUPPORT_EMAIL}</a>
                        {' '}manziliga "Akkauntni oʼchirish" mavzusida xat yuboring. Soʼrovingiz
                        30 kun ichida bajariladi.
                    </p>
                </Section>

                <Section title="Qaysi maʼlumotlar oʼchiriladi">
                    <ul className={css(styles.list)}>
                        <li>Hisob maʼlumotlari: ism, familiya, telefon/elektron pochta;</li>
                        <li>Barcha moliyaviy yozuvlar: kirim/chiqim, summalar, kategoriyalar va izohlar;</li>
                        <li>Sessiya tokenlari va kirish maʼlumotlari.</li>
                    </ul>
                    <p className={css(styles.p)}>
                        Oʼchirish amalini ortga qaytarib boʼlmaydi. Qonun talab qilgan hollarda
                        ayrim maʼlumotlar cheklangan muddatga saqlanishi mumkin.
                    </p>
                </Section>

                <Section title="Bogʼlanish">
                    <p className={css(styles.p)}>
                        Savollar boʼlsa:{' '}
                        <a className={css(styles.link)} href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
                    </p>
                </Section>

                <p className={css(styles.footer)}>© 2026 {COMPANY}. Barcha huquqlar himoyalangan.</p>
            </div>
        </div>
    )
}

function Section({ title, children }) {
    return (
        <div className={css(styles.section)}>
            <h2 className={css(styles.h2)}>{title}</h2>
            {children}
        </div>
    )
}

const styles = StyleSheet.create({
    page: {
        minHeight: '100vh',
        backgroundColor: '#f8fafc',
        padding: '2rem 1rem',
    },
    container: {
        maxWidth: '760px',
        margin: '0 auto',
        backgroundColor: '#ffffff',
        borderRadius: '16px',
        padding: '2.5rem',
        boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
        fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
        color: '#0f172a',
        lineHeight: 1.7,
    },
    title: {
        fontSize: '2rem',
        fontWeight: 700,
        margin: '0 0 0.25rem',
        color: '#D97757',
    },
    updated: { fontSize: '0.9rem', color: '#64748b', margin: '0 0 1.5rem' },
    section: { marginBottom: '1.5rem' },
    h2: { fontSize: '1.2rem', fontWeight: 600, margin: '0 0 0.5rem' },
    p: { fontSize: '1rem', margin: '0 0 0.5rem' },
    list: { fontSize: '1rem', paddingLeft: '1.25rem', margin: '0 0 0.5rem' },
    link: { color: '#D97757', textDecoration: 'none' },
    footer: { marginTop: '2rem', fontSize: '0.85rem', color: '#94a3b8', textAlign: 'center' },
})
